import React, { useEffect, useState, useRef } from 'react'
import ProductCard from '../../ProductCard';
import Glide from '@glidejs/glide';
declare global {
  interface Window {
    SWGetExpressWishlistId:() => any
    SWGetCustomerWishlistId: () => any
    ReloadSmartWishlist(): () => any
  }
}

interface iProps {
  dataSet: {
    customerId: string
    sectionTitle: string
    fromText: string
    roastText: string
    tastesText: string
    quickAddText: string
    quickAddPlus: string
    colourSwatches: string
  }
}

const WishListProducts: React.FunctionComponent<iProps> = ({ dataSet }): JSX.Element => {
  const [wishListProds, setWishListProds] = useState([])
  const [loading, setLoading] = useState(true);
  const [showGlide, setShowGlide] = useState(false)
  const { customerId, fromText, roastText, tastesText, colourSwatches, quickAddPlus, quickAddText, sectionTitle } = dataSet
  const glideEl = useRef();
  const glideOptions = {
    type: 'carousel',
    perView: 3,
    perTouch: false,
    touchRatio: 0.5,
    dragThreshold: 50,
    gap: 0,
    peek: {
      before: 0,
      after: 0
    },
    breakpoints: {
      '1440': {
        perView: 2.25,
        peek: {
          before: 0,
          after: 0
        },
      },
      '768': {
        perView: 1.25,
        perTouch: 1,
        gap: 24,
        peek: {
          before: 0,
          after: 0
        }
      },
    },
  }
  useEffect(() => {
    const customer = customerId ? parseInt(customerId) : window.SWGetCustomerWishlistId
    const wishListId = window.SWGetCustomerWishlistId
    let wishListUrl = '/a/wishlist?type=api&';
    wishListUrl += customer === 0 ? 'wishlistid=' + wishListId : 'customerid=' + customer;
    wishListUrl += '&version=1';

    fetch(wishListUrl)
      .then(e => {return e.json()})
      .then(data => {      
        setWishListProds(data.items);
        setLoading(false);
        if (window['ReloadSmartWishlist']) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.ReloadSmartWishlist()
        }
        
      })
      .catch((e) => {
        console.error(e)
        setLoading(false);
      });
  }, [setWishListProds])

  useEffect(() => {
    wishListProds.forEach(prod => {
      prod.tags = prod.tags.length ? prod.tags.split(','): [];
      const variant = { id: prod.variant_id, sku: prod.variant_sku }
      prod.featured_image = prod.image ? prod.image.split('https:')[1] : ''
      prod.price = prod.variant_price
      prod.variants = [variant]
    })
    wishListProds.length > 3 ? setShowGlide(true) : setShowGlide(false)
  }, [wishListProds])

  useEffect(() => {
    if (showGlide) {
      const slider = new Glide(glideEl.current, glideOptions);
      slider.mount();
    }
  }, [showGlide])

  if (wishListProds.length === 0) {
    return <></>
  }

  if (loading) {
    return <p className="loading-widget">...</p>;
  }
  return (
    wishListProds && wishListProds.length > 0 ? (
      <div ref={glideEl} className="cl-product-card-container section-spacer glide--ltr flex flex-column al-glidify relative">
        <div className="container">
          <header>
            <h2 className="heading-2 cl-product-title">{sectionTitle}</h2>
          </header>
          <div className="glide__track" data-glide-el="track">
            <ul className={showGlide ? 'glide__slides' : 'glide-grid'}>
              {wishListProds.map((product, i) => {
                return <li key={i}>
                  <ProductCard
                    product={product}
                    showSelect={false}
                    fromText={fromText}
                    roastText={roastText}
                    tasteText={tastesText}
                    colourSwatches={colourSwatches}
                    quickAddPlus={quickAddPlus}
                    quickAddText={quickAddText}
                  />
                </li>
              })}
            </ul>
          </div>
          {showGlide && <div className="controls flex align-center gap-small" data-glide-el="controls">
            <span className="glide__arrow glide__arrow--left" data-glide-dir="<" data-desktop-arrow>
              <span className="visually-hidden">Previous Slide</span>
            </span>
            <span className="glide__arrow glide__arrow--right" data-glide-dir=">" data-desktop-arrow>
              <span className="visually-hidden">Next Slide</span>
            </span>
          </div>}
        </div>
      </div>
    ) : null
  )
}

export default WishListProducts